import {
  CREATE_VENDOR,
  CREATE_VENDOR_RESPONSE,
  CREATE_VENDOR_RESPONSE_FAIL,
  GET_VENDOR,
  GET_VENDOR_RESPONSE,
  GET_VENDOR_RESPONSE_FAIL,
  GET_VENDORS,
  GET_VENDORS_RESPONSE,
  GET_VENDORS_RESPONSE_FAIL,
  RESET,
  UPDATE_VENDOR,
  UPDATE_VENDOR_RESPONSE,
  UPDATE_VENDOR_RESPONSE_FAIL,
  GET_VENDOR_RIDER_RATE_REQUEST,
  GET_VENDOR_RIDER_RATE_RESPONSE,
  GET_VENDOR_RIDER_RATE_FAIL,
  UPDATE_LOCAL_VENDOR_RIDER_RATES,
  CREATE_VENDOR_RIDER_RATE_REQUEST,
  CREATE_VENDOR_RIDER_RATE_RESPONSE,
  UPDATE_VENDOR_RIDER_RATE_REQUEST,
  UPDATE_VENDOR_RIDER_RATE_RESPONSE,
  DELETE_VENDOR_RIDER_RATE_REQUEST,
  DELETE_VENDOR_RIDER_RATE_RESPONSE,
  GET_VENDOR_BASE_CHARGE_REQUEST,
  GET_VENDOR_BASE_CHARGE_RESPONSE,
  GET_VENDOR_BASE_CHARGE_FAIL,
  UPDATE_LOCAL_VENDOR_BASE_CHARGES,
  CREATE_VENDOR_BASE_CHARGE_REQUEST,
  CREATE_VENDOR_BASE_CHARGE_RESPONSE,
  UPDATE_VENDOR_BASE_CHARGE_REQUEST,
  UPDATE_VENDOR_BASE_CHARGE_RESPONSE,
  DELETE_VENDOR_BASE_CHARGE_REQUEST,
  DELETE_VENDOR_BASE_CHARGE_RESPONSE,
  GET_VENDOR_PROPERTIES_REQUEST,
  GET_VENDOR_PROPERTIES_RESPONSE,
  GET_VENDOR_PROPERTIES_FAIL,
} from "./actions";

const initialState = {
  isLoading: false,
  error: null,
  riderRatesAreLoading: false,
  riderRatesProcessingErrors: null,
  baseChargesAreLoading: false,
  baseChargesProcessingErrors: null,
  vendorPropertiesAreLoading: false,
  data: {
    vendorsList: {
      items: [],
    },
    vendor: null,
    searchQuery: null,
    range: { start: 0, end: 25 },
    vendorRiderRates: { items: [], toUpdate: [], toDelete: [] },
    vendorBaseCharges: { items: [], toUpdate: [], toDelete: [] },
    vendorProperties: { items: [] },
  },
};

// State
export default (state = initialState, action) => {
  switch (action.type) {
    case RESET:
      return Object.assign({}, initialState);

    case GET_VENDORS:
    case GET_VENDOR:
    case CREATE_VENDOR:
    case UPDATE_VENDOR:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading,
      };

    case GET_VENDORS_RESPONSE:
      return {
        ...state,
        data: {
          ...state.data,
          vendorsList: {
            ...state.data.vendorsList,
            items: action.vendors,
          },
        },
        error: null,
        isLoading: false,
      };

    case GET_VENDOR_RESPONSE:
      return {
        ...state,
        data: {
          ...state.data,
          vendor: action.vendor,
        },
        error: null,
        isLoading: false,
      };

    case CREATE_VENDOR_RESPONSE:
      return {
        ...state,
        data: {
          ...state.data,
          vendor: action.vendor,
          vendorsList: {
            ...state.data.vendorsList,
            items: [...state.data.vendorsList.items, action.vendor],
          },
        },
        error: null,
        isLoading: false,
      };

    case UPDATE_VENDOR_RESPONSE:
      return {
        ...state,
        data: {
          ...state.data,
          vendor: action.vendor,
          vendorsList: {
            ...state.data.vendorsList,
            items: state.data.vendorsList.items.map((vendor) =>
              vendor.uuid === action.vendor.uuid ? action.vendor : vendor
            ),
          },
        },
        error: null,
        isLoading: false,
      };

    case GET_VENDORS_RESPONSE_FAIL:
    case GET_VENDOR_RESPONSE_FAIL:
    case CREATE_VENDOR_RESPONSE_FAIL:
    case UPDATE_VENDOR_RESPONSE_FAIL:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };

    case GET_VENDOR_RIDER_RATE_REQUEST:
      return {
        ...state,
        riderRatesProcessingErrors: null,
        riderRatesAreLoading: true,
      };

    case GET_VENDOR_RIDER_RATE_RESPONSE:
      return {
        ...state,
        data: {
          ...state.data,
          vendorRiderRates: {
            items: action.vendorRiderRates || [],
            toUpdate: [],
            toDelete: [],
          },
        },
        riderRatesProcessingErrors: action.error || null,
        riderRatesAreLoading: false,
      };

    case GET_VENDOR_RIDER_RATE_FAIL:
      return {
        ...state,
        riderRatesProcessingErrors: action.error,
        riderRatesAreLoading: false,
      };

    case UPDATE_LOCAL_VENDOR_RIDER_RATES:
      return {
        ...state,
        data: {
          ...state.data,
          vendorRiderRates: action.newRiderRates,
        },
      };

    case UPDATE_VENDOR_RIDER_RATE_REQUEST:
      return {
        ...state,
        riderRatesProcessingErrors: null,
      };

    case UPDATE_VENDOR_RIDER_RATE_RESPONSE:
      return {
        ...state,
        riderRatesProcessingErrors: action.error || null,
      };

    case CREATE_VENDOR_RIDER_RATE_REQUEST:
      return {
        ...state,
        riderRatesAreLoading: true,
        riderRatesProcessingErrors: null,
      };

    case CREATE_VENDOR_RIDER_RATE_RESPONSE: {
      let newItems = state.data.vendorRiderRates.items;
      if (action.newData) {
        newItems = newItems.concat(action.newData);
      }
      return {
        ...state,
        data: {
          ...state.data,
          vendorRiderRates: { items: newItems, toUpdate: [], toDelete: [] },
        },
        riderRatesAreLoading: false,
        riderRatesProcessingErrors: action.error || null,
      };
    }

    case DELETE_VENDOR_RIDER_RATE_REQUEST:
      return {
        ...state,
        riderRatesProcessingErrors: null,
      };

    case DELETE_VENDOR_RIDER_RATE_RESPONSE:
      return {
        ...state,
        riderRatesProcessingErrors: action.error || null,
      };

    case GET_VENDOR_BASE_CHARGE_REQUEST:
      return {
        ...state,
        baseChargesProcessingErrors: null,
        baseChargesAreLoading: true,
      };

    case GET_VENDOR_BASE_CHARGE_RESPONSE:
      return {
        ...state,
        data: {
          ...state.data,
          vendorBaseCharges: {
            items: action.vendorBaseCharges || [],
            toUpdate: [],
            toDelete: [],
          },
        },
        baseChargesProcessingErrors: action.error || null,
        baseChargesAreLoading: false,
      };

    case GET_VENDOR_BASE_CHARGE_FAIL:
      return {
        ...state,
        baseChargesProcessingErrors: action.error,
        baseChargesAreLoading: false,
      };

    case UPDATE_LOCAL_VENDOR_BASE_CHARGES:
      return {
        ...state,
        data: {
          ...state.data,
          vendorBaseCharges: action.newBaseCharges,
        },
      };

    case UPDATE_VENDOR_BASE_CHARGE_REQUEST:
      return {
        ...state,
        baseChargesProcessingErrors: null,
      };

    case UPDATE_VENDOR_BASE_CHARGE_RESPONSE:
      return {
        ...state,
        baseChargesProcessingErrors: action.error || null,
      };

    case CREATE_VENDOR_BASE_CHARGE_REQUEST:
      return {
        ...state,
        baseChargesAreLoading: true,
        baseChargesProcessingErrors: null,
      };

    case CREATE_VENDOR_BASE_CHARGE_RESPONSE: {
      let newItems = state.data.vendorBaseCharges.items;
      if (action.newData) {
        newItems = newItems.concat(action.newData);
      }
      return {
        ...state,
        data: {
          ...state.data,
          vendorBaseCharges: { items: newItems, toUpdate: [], toDelete: [] },
        },
        baseChargesAreLoading: false,
        baseChargesProcessingErrors: action.error || null,
      };
    }

    case DELETE_VENDOR_BASE_CHARGE_REQUEST:
      return {
        ...state,
        baseChargesProcessingErrors: null,
      };

    case DELETE_VENDOR_BASE_CHARGE_RESPONSE:
      return {
        ...state,
        baseChargesProcessingErrors: action.error || null,
      };

    case GET_VENDOR_PROPERTIES_REQUEST:
      return {
        ...state,
        vendorPropertiesAreLoading: true,
        error: null,
      };

    case GET_VENDOR_PROPERTIES_RESPONSE:
      return {
        ...state,
        data: {
          ...state.data,
          vendorProperties: {
            items: action.vendorProperties || [],
          },
        },
        vendorPropertiesAreLoading: false,
        error: null,
      };

    case GET_VENDOR_PROPERTIES_FAIL:
      return {
        ...state,
        vendorPropertiesAreLoading: false,
        error: action.error,
      };

    default:
      return {
        ...state,
      };
  }
};